<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="color"
        :label="label"
        :error-messages="errorMessages"
        readonly
        v-bind="attrs"
        v-on="on"
        :color="color"
      >
        <template v-slot:prepend-inner>
          <v-icon :color="color">palette</v-icon>
        </template>
        <template v-slot:append>
          <v-btn x-small rounded dark :color="color" @click="$store.dispatch('theme/startPreview', color)" :disabled="$store.state.theme.preview">Test</v-btn>
        </template>
      </v-text-field>
    </template>
    <v-color-picker v-model="color" show-swatches/>
  </v-menu>
</template>

<script>
export default {
  name: 'ColorSelector',
  props: {
    label: {type: String, required: false, default: ''},
    value: {type: String, required: true},
    errorMessages: {type: Array, required: false, default: () => []}
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    color: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>